const Testimonials = (testimonials) => {
    const view = testimonials.posts
      .map((testimonial) => {
        return `
        <div class="testimonial entry-content text-center">

            <img class="testimonial-icon img-fluid" src="/wp-content/themes/horizon-mercury/dist/images/testimonials-icon.png" alt="Testimonials">
            
            <blockquote>
                <q>
                    ${testimonial['testimonial-content']}
                </q>
                <cite>
                    - ${testimonial['testimonial-client']}
                </cite>
            </blockquote>

        </div>
          `;
      })
      .join('');
    return view;
  };
  
  export default Testimonials;